import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { useAuth } from "./AuthContext";

const DataContext = createContext(null);
export const useData = () => useContext(DataContext);

export function DataProvider({ children }) {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [projects, setProjects] = useState([]);
  const [lookups, setLookups] = useState([]);
  const [favourites, setFavourites] = useState({ task: new Set(), project: new Set(), workspace: new Set(), document: new Set() });

  const loadFavourites = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/favourites");
      const t = new Set(), p = new Set(), w = new Set(), dc = new Set();
      data.forEach((f) => { const s = f.entity_type === "project" ? p : f.entity_type === "workspace" ? w : f.entity_type === "document" ? dc : t; s.add(f.entity_id); });
      setFavourites({ task: t, project: p, workspace: w, document: dc });
    } catch {}
  }, [user]);

  const toggleFavourite = async (entity_type, entity_id) => {
    const { data } = await api.post("/favourites/toggle", { entity_type, entity_id });
    setFavourites((prev) => {
      const next = { task: new Set(prev.task), project: new Set(prev.project), workspace: new Set(prev.workspace), document: new Set(prev.document) };
      if (data.favourite) next[entity_type].add(entity_id); else next[entity_type].delete(entity_id);
      return next;
    });
    return data.favourite;
  };
  const isFavourite = (entity_type, id) => favourites[entity_type].has(id);

  const load = useCallback(async () => {
    if (!user) return;
    try {
      const [u, d, p, l] = await Promise.all([
        api.get("/users"),
        api.get("/departments"),
        api.get("/projects"),
        api.get("/lookups"),
      ]);
      setUsers(u.data);
      setDepartments(d.data);
      setProjects(p.data);
      setLookups(l.data);
    } catch {}
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    loadFavourites();
  }, [loadFavourites]);

  const userName = (id) => users.find((x) => x.id === id)?.full_name || (id ? "—" : "—");
  const deptName = (id) => departments.find((x) => x.id === id)?.name || "—";
  const projName = (id) => projects.find((x) => x.id === id)?.name || "—";
  const lookupsBy = (cat) => lookups.filter((x) => x.category === cat);

  return (
    <DataContext.Provider
      value={{ users, departments, projects, lookups, userName, deptName, projName, lookupsBy, reload: load,
               favourites, toggleFavourite, isFavourite, reloadFavourites: loadFavourites }}
    >
      {children}
    </DataContext.Provider>
  );
}
